<script setup>
import { NumberFieldDecrement, NumberFieldIncrement, NumberFieldInput, NumberFieldRoot } from 'radix-vue'

const model = defineModel()
</script>

<template>
  <NumberFieldRoot
    :min="9"
    :max="150"
    v-model="model"
    class="w-full"

  >
     <NumberFieldInput class="tabular-nums input w-full"  />
  </NumberFieldRoot>
</template>